import { Injectable, Component, OnInit, Input, EventEmitter } from '@angular/core';
import { ConfigDB } from '../../common/data/config/config';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../services/api.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class ReportingService {

    
    public firstReference: string = '';
    public secondReference: string = '';
    public firstRefKeys: any = [];
    public secRefKeys: any = [];
    public reportsQueue: any = [];
    public rptTriggerPoint: any;
    public productCde: string = '';
    public processCde: string = '';
    public reportingServiceEvent = new EventEmitter();

    wizard: any;

    constructor(
        private apiService: ApiService,
        private toastrService: ToastrService,
        private translate: TranslateService)
    {
    }

    printAutomaticReportsInQueue(triggerPoint, referenceKeys, secondReferenceKeys) {
        this.firstRefKeys = referenceKeys;
        this.secRefKeys = secondReferenceKeys;
        this.rptTriggerPoint = triggerPoint;

        this.printNextReportFromQueue();
    }


    printAutomaticReportsInQueueByProcess(triggerPoint, processCode, productCode, referenceKeys, secondReferenceKeys) {
        this.firstRefKeys = referenceKeys;
        this.secRefKeys = secondReferenceKeys;
        this.rptTriggerPoint = triggerPoint;
        this.productCde = productCode;
        this.processCde = processCode;

        this.printNextReportFromQueue();
    }


    printNextReportFromQueue() {
        if (this.firstRefKeys.length > 0) this.firstReference = this.firstRefKeys[0];
        if (this.secRefKeys.length > 0) this.secondReference = this.secRefKeys[0];

        this.printAutomaticReports(this.rptTriggerPoint, this.firstReference, this.secondReference);
    }


    printAutomaticReports(triggerPoint, referenceNum, secondReferenceNum) {
        this.firstReference = referenceNum;
        this.secondReference = secondReferenceNum;

        var model = {
            TriggerPointRef: triggerPoint,
            RefNumber: this.firstReference,
            SecondRefNumber: this.secondReference,
            ProcessCde: this.processCde,
            PlanCde: this.productCde
        };

        this.apiService.post("Api/reportApi/List/", model).subscribe((result: any) => {
            var reports = result.rows;
            this.reportsQueue = reports;

            if (this.reportsQueue.length > 0)
                this.printReportInQueue();
            //else
                //this.toastrService.error(this.translate.instant("Failed to print report."));
        });
    }

    printProcess(processCode, planCode, referenceNum, secondReferenceNum, printTriggerPoint) {

        this.firstReference = referenceNum;
        this.secondReference = secondReferenceNum;

        var model = {
            ProcessCde: processCode,
            PlanCde: planCode,
            TriggerPointRef: printTriggerPoint,
            RefNumber: referenceNum,
            SecondRefNumber: this.secondReference
        };


        this.apiService.post("Api/reportApi/List/", model).subscribe((result: any) => {

            var reports = result.rows;
            this.reportsQueue = reports;

            if (this.reportsQueue.length > 0)
                this.printReportInQueue();
            else
                this.toastrService.warning(this.translate.instant("No Reports Available."));

        });
    }


    printTaskRuleReport(taskRuleCde) {
        this.firstReference = taskRuleCde;

        var model = {
            TaskRuleKey: taskRuleCde
        };

        this.apiService.post("Api/reportApi/ListTaskRuleReports/", model).subscribe((result: any) => {

            var reports = result.data.rows;
            this.reportsQueue = reports;

            if (this.reportsQueue.length > 0)
                this.printReportInQueue();
            else
                this.toastrService.error(this.translate.instant("Failed to print report."));
        });

    }

    //printReports(reports, referenceNum) {
    //    for (var i = 0; i < reports.length; i++)
    //        this.printReportInQueue(reports[i].PrintListCde, reports[i].ReportName, referenceNum)
    //}


    printReportInQueue() {
        var printListCde = this.reportsQueue[0].PrintListCde;
        var reportName = this.reportsQueue[0].ReportName;
        var reponseType = { responseType: 'arrayBuffer' };
        this.toastrService.success(this.translate.instant("Printing report "), reportName);
        

        var model = {
            PrintListCde: printListCde,
            ReportName: reportName,
            RefNumber: this.firstReference,
            SecondRefNumber: this.secondReference
        };

     //   apiService.post(rootDir + '', model, reportPrintCompleted, reportPrintFailed, reponseType);
        //myObservable.subscribe( x => console.log('Observer got a next value: ' + x), 
        //err => console.error('Observer got an error: ' + err), () => console.log('Observer got a complete notification') ); 

        this.apiService.postWithOptions("Api/reportApi/Print/", model, reponseType).subscribe((result: any) => {

            const blob = new Blob([result], { type: 'application/pdf' });
            var dbReportName = reportName;
           
            var curDate = new Date();
            if (dbReportName)
              var tempReportName = dbReportName + "_" + curDate.getHours() + curDate.getMinutes() + curDate.getSeconds() + curDate.getMilliseconds() + ".pdf";
            else
              var tempReportName = 'R' + "_" + curDate.getHours() + curDate.getMinutes() + curDate.getSeconds() + curDate.getMilliseconds() + ".pdf";

            //navigator is used here for IE browser
            if (result != null && navigator.msSaveOrOpenBlob)
                navigator.msSaveOrOpenBlob(blob, tempReportName);
            else {

                // Create a Blob from the binary data
                const blob = new Blob([result], { type: 'application/pdf' });

                // Create a Blob URL
                const blobUrl = URL.createObjectURL(blob);

                // Open a new window/tab with the Blob URL
                window.open(blobUrl, '_blank');

                

                var a = document.createElement("a");
                var url = window.URL.createObjectURL(blob);
                a.setAttribute("href", url);
                a.setAttribute("target", "_blank"); // Open in a new tab
                a.setAttribute("download", tempReportName);
                document.createElement("body").append(a);
                a.click();
                // Clean up the Blob URL when no longer needed
                URL.revokeObjectURL(blobUrl);

                a.remove();
            }

            if (dbReportName)
                this.toastrService.success(dbReportName, this.translate.instant(" printed successfully."));

            else
                this.toastrService.error(this.translate.instant("Failed to print report."));

            //printNextReport();
            this.executePostTrigger();
        },
            //catch error
            err => console.error('Observer got an error: ' + err), 
        );
    }

    printReport(printListCde, reportName, firstReference, secondReference, printType = 'R') {
        var reponseType = { responseType: 'arrayBuffer' };
        this.toastrService.success(this.translate.instant("Printing report "), reportName);


        var model = {
            PrintListCde: printListCde,
            ReportName: reportName,
            RefNumber: firstReference,
            SecondRefNumber: secondReference,
            PrintType: printType
        };

        //   apiService.post(rootDir + '', model, reportPrintCompleted, reportPrintFailed, reponseType);
        //myObservable.subscribe(x=>console.log('Observer got a next value: '+x),
        //err => console.error('Observer got an error: ' + err), () => console.log('Observer got a complete notification')�); 

        this.apiService.postWithOptions("Api/reportApi/Print/", model, reponseType).subscribe((result: any) => {

            const blob = new Blob([result], { type: 'application/pdf' });
            var dbReportName = reportName;

            var curDate = new Date();
            if (dbReportName)
                var tempReportName = dbReportName + "_" + curDate.getHours() + curDate.getMinutes() + curDate.getSeconds() + curDate.getMilliseconds() + ".pdf";
            else
                var tempReportName = 'R' + "_" + curDate.getHours() + curDate.getMinutes() + curDate.getSeconds() + curDate.getMilliseconds() + ".pdf";

            //navigator is used here for IE browser
            if (result != null && navigator.msSaveOrOpenBlob)
                navigator.msSaveOrOpenBlob(blob, tempReportName);
            else {
                var a = document.createElement("a");
                var url = window.URL.createObjectURL(blob);
                a.setAttribute("href", url);
                a.setAttribute("download", tempReportName);
                document.createElement("body").append(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            }

            if (dbReportName)
                this.toastrService.success(dbReportName, this.translate.instant(" printed successfully."));

            else
                this.toastrService.error(this.translate.instant("Failed to print report."));

            //printNextReport();
            this.executePostTrigger2(printListCde, reportName);
        },
            //catch error
            err => console.error('Observer got an error: ' + err),
        );
    }

    executePostTrigger2(printListCde, reportName) {
        //var printListCde = this.reportsQueue[0].PrintListCde;
        //var reportName = this.reportsQueue[0].ReportName;

        var model = {
            PrintListCde: printListCde,
            ReportName: reportName,
            RefNumber: this.firstReference,
            SecondRefNumber: this.secondReference
        };


        this.apiService.post("Api/reportApi/ExecutePostTrigger/", model).subscribe((result: any) => {

            if (result) {
                this.printNextReport();
            }
            else {
                this.toastrService.error(this.translate.instant("Failed to execute report post trigger."));
                this.printNextReport();
            }

        });
    }

    executePostTrigger() {
        var printListCde = this.reportsQueue[0].PrintListCde;
        var reportName = this.reportsQueue[0].ReportName;

        var model = {
            PrintListCde: printListCde,
            ReportName: reportName,
            RefNumber: this.firstReference,
            SecondRefNumber: this.secondReference
        };


        this.apiService.post("Api/reportApi/ExecutePostTrigger/", model).subscribe((result: any) => {

            if (result) {
                this.printNextReport();
            }
            else {
                this.toastrService.error(this.translate.instant("Failed to execute report post trigger."));
                this.printNextReport();
            }

        });
    }


    printNextReport() {
        if (this.reportsQueue.length > 0) this.reportsQueue.splice(0, 1);
        if (this.reportsQueue.length > 0)
            this.printReportInQueue();
        else {
            if (this.firstRefKeys.length > 0) this.firstRefKeys.splice(this.firstRefKeys.indexOf(this.firstReference), 1);
            if (this.secRefKeys.length > 0) this.secRefKeys.splice(this.secRefKeys.indexOf(this.secondReference), 1);
            if (this.firstRefKeys.length > 0) this.printNextReportFromQueue();
            else {
                //TODO
                //this.reportingServiceEvent.emit('reportprint:update'); // added by Biswa
                //$rootScope.$broadcast('reportprint:update', null);

            }
        }
    }


    exportExcel(header, colHeaders, colNames, data) {
        var html = "";
        //write header
        html = "<html><head><style>.text{ mso-number-format:'\@';}</style></head><body><table><tr>"
        for (var i = 0; i < colNames.length; i++) {
            if (colNames[i].hidden != true && (colNames[i].formatter == 'undefined' || colNames[i].formatter == null || colNames[i].formatter == 'date' || colNames[i].formatter.toString().indexOf('formatterNumber') > 0)) {
                html += "<th>" + colHeaders[i] + "</th>";
            }
        }
        html += '</tr>';

        var colName = '';
        var coldata = '';
        //var dtVal = '';
        var day = '';
        var month = '';
        var year = '';
        var hrs = '';
        var mins = '';
        var sec = '';

        for (var k = 0; k < data.rows.length; k++) {
            html += '<tr>';
            for (var j = 0; j < colNames.length; j++) {
                if (colNames[j].hidden != true && (colNames[j].formatter == 'undefined' || colNames[j].formatter == null || colNames[j].formatter == 'date' || colNames[j].formatter.toString().indexOf('formatterNumber') > 0)) {
                    if (colNames[j].formatter == 'date') {
                        if (data.rows[k][colNames[j].name] != 'undefined' || data.rows[k][colNames[j].name] != null || data.rows[k][colNames[j].name] != '') {
                            const dtVal: Date = new Date(data.rows[k][colNames[j].name]);
                            //coldata = dtVal.toLocaleString();
                            day = dtVal.getDate().toString();
                            month = (dtVal.getMonth() + 1).toString();
                            year = dtVal.getFullYear().toString();
                            hrs = dtVal.getHours().toString();
                            mins = dtVal.getMinutes().toString();
                            sec = dtVal.getSeconds().toString();
                            coldata = day + "/" + month + "/" + year + " " + hrs + ":" + mins + ":" + sec;
                        }
                        else {
                            coldata = '';
                        }

                    }
                    else
                        coldata = data.rows[k][colNames[j].name];
                    if (colNames[j].align == 'left')
                        html += "<td class='text'>" + coldata + "</td>";
                    else
                        html += "<td>" + coldata + "</td>";
                }

            }
            html += '</tr>';
        }
        html += '</table></body></html>';

        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>';
        var base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)))
        };

        var format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
                return c[p];
            })
        };

        var ctx = {
            worksheet: 'Data',
            table: "\ufeff" + html
        }
        // "\ufeff" to fix the issue with french accented characters


        var blob = new Blob([format(template, ctx)], { type: 'application/vnd.ms-excel'});
        var curDate = new Date();
        var fileName = header + "_" + curDate.getHours() + curDate.getMinutes() + curDate.getSeconds() + curDate.getMilliseconds() + ".xls";
        if (navigator.msSaveOrOpenBlob)
            navigator.msSaveOrOpenBlob(blob, fileName);
        else {
            var a = document.createElement("<a style='display: none;'/>");
            var url = window.URL.createObjectURL(blob);
            a.setAttribute("href", url);
            a.setAttribute("download", fileName);
            document.createElement("body").append(a);
            a[0].click();
            window.URL.revokeObjectURL(url);
            a.remove();
        }


    }

    exportSQLExtract(header, colHeaders, colNames, data) {
        var html = "";
        //write header
        html = "<html><head><style>.text{ mso-number-format:'\@';}</style></head><body><table><tr>"
        for (var i = 0; i < colNames.length; i++) {
            if (colNames[i].hidden != true && (colNames[i].formatter == 'undefined' || colNames[i].formatter == null || colNames[i].formatter == 'date' || colNames[i].formatter.toString().indexOf('formatterNumber') > 0)) {
                html += "<th>" + colHeaders[i] + "</th>";
            }
        }
        html += '</tr>';

        var colName = '';
        var coldata = '';
     //   var dtVal = '';
        var day = '';
        var month = '';
        var year = '';
        var hrs = '';
        var mins = '';
        var sec = '';

        for (var k = 0; k < data.rows.length; k++) {
            html += '<tr>';
            for (var j = 0; j < colNames.length; j++) {
                if (colNames[j].hidden != true && (colNames[j].formatter == 'undefined' || colNames[j].formatter == null || colNames[j].formatter == 'date' || colNames[j].formatter.toString().indexOf('formatterNumber') > 0)) {
                    if (colNames[j].formatter == 'date') {
                        if (data.rows[k][colNames[j].name] != 'undefined' || data.rows[k][colNames[j].name] != null || data.rows[k][colNames[j].name] != '') {
                           const dtVal: Date = new Date(data.rows[k][colNames[j].name]);
                            //coldata = dtVal.toLocaleString();
                            day = dtVal.getDate().toString();
                            month = (dtVal.getMonth() + 1).toString();
                            year = (dtVal.getFullYear()).toString();
                            hrs = dtVal.getHours().toString();
                            mins = dtVal.getMinutes().toString();
                            sec = dtVal.getSeconds().toString();
                            coldata = day + "/" + month + "/" + year + " " + hrs + ":" + mins + ":" + sec;
                        }
                        else {
                            coldata = '';
                        }

                    }
                    else
                        coldata = data.rows[k].Table[k][colNames[j]];
                    if (colNames[j].align == 'left')
                        html += "<td class='text'>" + coldata + "</td>";
                    else
                        html += "<td>" + coldata + "</td>";
                }

            }
            html += '</tr>';
        }
        html += '</table></body></html>';

        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>';
        var base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)))
        };

        var format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
                return c[p];
            })
        };

        var ctx = {
            worksheet: 'Data',
            table: "\ufeff" + html
        }
        // "\ufeff" to fix the issue with french accented characters


        var blob = new Blob([format(template, ctx)], { type: 'application/vnd.ms-excel'});
        var curDate = new Date();
        var fileName = header + "_" + curDate.getHours() + curDate.getMinutes() + curDate.getSeconds() + curDate.getMilliseconds() + ".xls";
        if (navigator.msSaveOrOpenBlob)
            navigator.msSaveOrOpenBlob(blob, fileName);
        else {
            var a = document.createElement("<a style='display: none;'/>");
            var url = window.URL.createObjectURL(blob);
            a.setAttribute("href", url);
            a.setAttribute("download", fileName);
            document.createElement("body").append(a);
            a[0].click();
            window.URL.revokeObjectURL(url);
            a.remove();
        }


    }



}

